"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";

import { getLanguageFromPathname } from "@/lib/i18n/paths";
import { createTranslator } from "@/lib/i18n/translations";

/**
 * Friendly 404 shown for unknown routes. Reads the language from the URL
 * because not-found boundaries don't receive route params.
 */
export function NotFoundView() {
  const lang = getLanguageFromPathname(usePathname());
  const t = createTranslator(lang);

  return (
    <section className="mx-auto flex min-h-[50vh] max-w-xl flex-col items-center justify-center gap-3 py-8 text-center sm:min-h-[60vh] sm:gap-4 sm:py-16">
      <p aria-hidden className="text-5xl sm:text-7xl">
        🐝
      </p>
      <p className="text-sm font-semibold uppercase tracking-widest text-success">
        404
      </p>
      <h1 className="text-2xl font-bold sm:text-4xl">
        {t("errors.notFoundTitle")}
      </h1>
      <p className="text-default-500">{t("errors.notFoundDescription")}</p>
      <div className="mt-2 flex w-full flex-col gap-3 sm:w-auto sm:flex-row sm:justify-center">
        <Link
          className="min-h-11 rounded-full bg-success px-5 py-2.5 text-center font-semibold text-success-foreground transition-opacity hover:opacity-90"
          href={`/${lang}/movies`}
        >
          {t("errors.browseMovies")}
        </Link>
        <Link
          className="min-h-11 rounded-full bg-default-100 px-5 py-2.5 text-center font-semibold transition-colors hover:bg-default-200"
          href={`/${lang}`}
        >
          {t("errors.goHome")}
        </Link>
      </div>
    </section>
  );
}
